import {
  SEARCH_BASE_URL,
  POPULAR_BASE_URL,
  API_URL,
  API_KEY,
  REQUEST_TOKEN_URL,
  LOGIN_URL,
  SESSION_ID_URL,
  API_TOKEN,
} from './config';

const defaultConfig = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer '+API_TOKEN
  }
};



const apiSettings = {
  fetchMovies: async (searchTerm, page, startDate,endDate) => {
    const endpoint = searchTerm
      ? `${POPULAR_BASE_URL}?apikey=${API_KEY}&searchTerm=${searchTerm}&startDate=${startDate}&endDate=${endDate}`
      : `${POPULAR_BASE_URL}?apikey=${API_KEY}&startDate=${startDate}&endDate=${endDate}`;
      console.log(endpoint)
      console.log("net voor fetch response")
    
    return await (await fetch(endpoint,{...defaultConfig})).json();
  },
  fetchBesluit: async movieId => {
    const endpoint = `${POPULAR_BASE_URL}/${movieId}?apikey=${API_KEY}`;
    
    console.log(endpoint)
    return await (await fetch(endpoint)).json();
  },
  fetchCredits: async movieId => {
    const creditsEndpoint = `${API_URL}movie/${movieId}/credits?api_key=${API_KEY}`;
    return await (await fetch(creditsEndpoint)).json();
  },
  // Bonus material below for login
  getRequestToken: async () => {
    const reqToken = await (await fetch(REQUEST_TOKEN_URL)).json();
    return reqToken.request_token;
  },
  authenticate: async (requestToken, username, password) => {
    const bodyData = {
      username,
      password,
      request_token: requestToken
    };
    // First authenticate the requestToken
    const data = await (
      await fetch(LOGIN_URL, {
        ...defaultConfig,
        body: JSON.stringify(bodyData)
      })
    ).json();
    // Then get the sessionId with the requestToken
    if (data.success) {
      const sessionId = await (
        await fetch(SESSION_ID_URL, {
          ...defaultConfig,
          body: JSON.stringify({ request_token: requestToken })
        })
      ).json();
      return sessionId;
    }
  },
  rateMovie: async (sessionId, movieId, value) => {
    const endpoint = `${API_URL}movie/${movieId}/rating?api_key=${API_KEY}&session_id=${sessionId}`;

    const rating = await (
      await fetch(endpoint, {
        ...defaultConfig,
        body: JSON.stringify({ value })
      })
    ).json();

    return rating;
  }
};

export default apiSettings;
